import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import EventCardsGrid from "../events/EventCardsGrid";
import { EventsListPageSkeleton } from "../events/EventPageSkeletons";
import { listAllEventsForAdmin } from "../events/eventsService";
import "../events/Events.css";
import "./AdminPage.css";

const EVENTS_PER_PAGE = 9;

const AdminPage = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    setError("");
    listAllEventsForAdmin({ page, pageSize: EVENTS_PER_PAGE })
      .then(({ events: nextEvents, totalCount: nextTotalCount }) => {
        if (!mounted) return;
        setEvents(nextEvents);
        setTotalCount(nextTotalCount);
      })
      .catch(
        (loadError) =>
          mounted && setError(loadError.message || "Could not load events.")
      )
      .finally(() => mounted && setIsLoading(false));
    return () => {
      mounted = false;
    };
  }, [page]);

  const pageCount = Math.max(1, Math.ceil(totalCount / EVENTS_PER_PAGE));

  if (isLoading) return <EventsListPageSkeleton />;

  return (
    <div className="events-page">
      <Header />
      <main className="events-shell">
        <div className="events-container">
          <div className="events-header">
            <div>
              <h1>Admin events</h1>
              <p>All events, newest first</p>
            </div>
          </div>
          {error && <div className="event-error" role="alert">{error}</div>}
          {!error && events.length > 0 && (
            <EventCardsGrid
              events={events}
              showEventDetails
              showEventOwner
              useFirstAttendeePreview
            />
          )}
          {!error && !events.length && <p>No events found.</p>}
          {!error && pageCount > 1 && (
            <nav className="admin-pagination" aria-label="Admin events pagination">
              <button
                className="button"
                disabled={page === 1}
                onClick={() => setPage((currentPage) => currentPage - 1)}
                type="button"
              >
                Previous
              </button>
              <span aria-live="polite">Page {page} of {pageCount}</span>
              <button
                className="button"
                disabled={page === pageCount}
                onClick={() => setPage((currentPage) => currentPage + 1)}
                type="button"
              >
                Next
              </button>
            </nav>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AdminPage;
